import {
  ADD_TO_PLAYLIST,
  REMOVE_FROM_PLAYLIST,
  SET_PLAYLIST,
  PLAY_PLAYLIST,
  RESET_PAIN_LEVELS_AND_SESSION_ID,
  RESET_SONG_INFO,
  FAIL_FETCH_MUSIC,
  START_FETCH_GENRES,
  START_FETCH_FROM_REMOTE,
  SET_IMMERSIVE_VIDEO,
  SET_PAIN_AFTER_LEVEL,
  SET_PAIN_BEFORE_LEVEL,
  SET_SESSION_ID,
  SET_INDICATION_TYPE,
  SET_SONG_ID,
  SET_ALL_SONGS,
  SET_ALL_GENRES,
  SET_PLAY_STATE,
  SET_DEMO_MODE,
  SET_SONG_INFO,
  SET_SONG_SESSION_INFO,
  REORDER_PLAYLIST,
  SET_PLAYED_TIME,
  SET_END_EVENT,
  SET_ALL_LOCAL_SONGS,
  SET_ALL_LOCAL_GENRES,
  SET_VOLUME,
  SET_SESSION_ONLINE,
  SET_SESSION_DB,
  SET_SESSION_DB_TABLE,
} from '../actions/actionTypes'

const initialState = {
  immersiveVideo: null,
  painLevelAfter: null,
  painLevelBefore: null,
  sessionId: null,
  indicationType: null,
  songId: null,
  songInfo: null,
  allSongs: [],
  allRawSongsMap: {},
  allGenresMap: {},
  allLocalGenresMap: {},
  allSongsMap: {},
  allLocalSongs: {},
  allLocalSongsMap: {},
  isFetchingGenres: false,
  isFetchingSongs: false,
  isFetchingSongsFromRemote: false,
  playState: false,
  volume: 1.0,
  demoMode: true,
  downloadedSongs: [],
  isDownloading: false,
  error: null,
  playlist: [],
  playingPlaylistSong: null,
  playedTime: null,
  endEvent: null,
  sessionDb: null,
  sessionDbTable: null,
  sessionOnline: false,
}

const playerReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PAIN_LEVELS_AND_SESSION_ID: {
      return {
        ...state,
        painLevelAfter: null,
        painLevelBefore: null,
        sessionId: null,
        playedTime: null,
        endEvent: null,
      }
    }

    case SET_PLAYED_TIME: {
      return { ...state, playedTime: action.payload }
    }

    case RESET_SONG_INFO: {
      return { ...state, songInfo: null }
    }

    case SET_IMMERSIVE_VIDEO: {
      return { ...state, immersiveVideo: action.payload }
    }

    case SET_PAIN_AFTER_LEVEL: {
      return { ...state, painLevelAfter: action.payload }
    }

    case SET_PAIN_BEFORE_LEVEL: {
      return {
        ...state,
        painLevelBefore: action.payload,
      }
    }

    case SET_SESSION_ID: {
      return {
        ...state,
        sessionId: action.payload,
      }
    }

    case SET_SONG_ID: {
      return {
        ...state,
        songId: action.payload,
      }
    }

    case SET_SONG_INFO: {
      return {
        ...state,
        songInfo: action.payload,
      }
    }

    case SET_SONG_SESSION_INFO: {
      const { indicationType, songId } = action.payload

      return {
        ...state,
        indicationType,
        songId,
        songInfo: null,
      }
    }

    case SET_ALL_SONGS: {
      const { allSongs, allSongsMap, allRawSongsMap, isFetchingSongsFromRemote } =
        action.payload
      return {
        ...state,
        isFetchingSongs: false,
        isFetchingSongsFromRemote,
        allSongs,
        allSongsMap,
        allRawSongsMap,
      }
    }

    case SET_ALL_LOCAL_SONGS: {
      const { allLocalSongs, allLocalSongsMap, isFetchingSongsFromRemote } =
        action.payload
      return { ...state, allLocalSongs, allLocalSongsMap, isFetchingSongsFromRemote }
    }

    case SET_ALL_GENRES: {
      return {
        ...state,
        allGenresMap: action.payload,
        isFetchingGenres: false,
        error: null,
      }
    }

    case SET_ALL_LOCAL_GENRES: {
      return {
        ...state,
        allLocalGenresMap: action.payload,
        error: null,
      }
    }

    case START_FETCH_GENRES: {
      return { ...state, isFetchingGenres: true, isFetchingSongs: true, error: null }
    }

    case START_FETCH_FROM_REMOTE: {
      const { isFetchingSongsFromRemote } = action.payload
      return { ...state, isFetchingSongsFromRemote }
    }

    case FAIL_FETCH_MUSIC: {
      return {
        ...state,
        isFetchingGenres: false,
        isFetchingSongs: false,
        error: action.payload,
      }
    }

    case SET_PLAY_STATE: {
      return { ...state, playState: action.payload }
    }

    case SET_VOLUME: {
      return { ...state, volume: action.payload }
    }

    case SET_DEMO_MODE: {
      return { ...state, demoMode: action.payload }
    }

    case SET_INDICATION_TYPE: {
      return {
        ...state,
        indicationType: action.payload,
      }
    }

    case ADD_TO_PLAYLIST: {
      const playlistAdded = [...new Set([...state.playlist, action.payload])]
      return { ...state, playlist: playlistAdded }
    }

    case REMOVE_FROM_PLAYLIST: {
      const playlistRemoved = state.playlist.filter((songId) => songId !== action.payload)
      return { ...state, playlist: playlistRemoved }
    }

    case SET_PLAYLIST: {
      return { ...state, playlist: action.payload }
    }

    case PLAY_PLAYLIST: {
      return { ...state, playingPlaylistSong: action.payload }
    }

    case REORDER_PLAYLIST: {
      const reorderedP = [...state.playlist]
      const firstIndex = action.payload.firstIndex
      const secondIndex = action.payload.secondIndex
      ;[reorderedP[firstIndex], reorderedP[secondIndex]] = [
        reorderedP[secondIndex],
        reorderedP[firstIndex],
      ]
      return { ...state, playlist: reorderedP }
    }

    case SET_END_EVENT: {
      return { ...state, endEvent: action.payload }
    }

    case SET_SESSION_DB: {
      return { ...state, sessionDb: action.payload }
    }

    case SET_SESSION_DB_TABLE: {
      return { ...state, sessionDbTable: action.payload }
    }

    case SET_SESSION_ONLINE: {
      return { ...state, sessionOnline: action.payload }
    }

    default:
      return { ...state }
  }
}

export default playerReducer
